import React from 'react';
import ImagemNotFound from 'assets/img/notFound.svg';
import * as S from './styles';
import { altImageNotFound } from 'utils/acessibilidade';

export default function NotFound() {
  return (
    <S.Contain>
      <S.Titulo>404</S.Titulo>
      <S.Subtitulo>Página não encontrada</S.Subtitulo>
      <S.Image data-testid="Imagem Page NotFound" src={ImagemNotFound} alt={altImageNotFound} />
    </S.Contain>
  );
}
